
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/moje-konto/uslugi-dodatkowe/roaming/strefy",
      function () {
        return require("private-next-pages/moje-konto/uslugi-dodatkowe/roaming/strefy.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/moje-konto/uslugi-dodatkowe/roaming/strefy"])
      });
    }
  